import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setCompaniesFullList } from 'src/store/modules/admin'

import { COMPANIES } from 'src/constants'

export const getCompaniesFullList = () => async (dispatch) => {
  try {
    const { items = [] } = await httpClient.request({
      method: 'get',
      url: {
        pathname: COMPANIES,
        query: {
          'per-page': 10000
        }
      }
    })

    dispatch(setCompaniesFullList(items))
  } catch (err) {
    catchError(err)
  }
}
